export default {"src":"/_next/static/media/fraction-strips.ec91d91f.svg","height":122,"width":143,"blurWidth":0,"blurHeight":0};